<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">
                <a-form-model-item ref="platformcode" label="平台编码" prop="platformcode">
                    <platformSelecter v-show="is_new" :platformcode="record.platformcode"  @platformChange="handlePlatformChange"></platformSelecter>
                    <span v-show="!is_new"> {{ platformName }} </span>
                </a-form-model-item>

                <!-- 非必须参数 -->
                <a-form-model-item ref="catalogcode" label="所属目录" prop="catalogcode">
                    <catalog v-if="is_new" :platformcode="record.platformcode" :mmkey="record.catalogcode" @catalogcodechange="handleCatlogChange" ></catalog>
                    <span v-else>{{record.catalogcode}}</span>
                </a-form-model-item>

                <!-- 必须参数 -->
                <a-form-model-item ref="rangerule" label="配置规则" prop="rangerule">
                    <rangerule v-if="is_new" :platformcode="record.platformcode" ref="rangeRuleSelecter" @rangeruleChange="handleRangeRuleChange" ></rangerule>
                    <span v-else>{{record.rangerulename}}</span>
                </a-form-model-item>

                <a-form-model-item ref="configcode" label="配置编码" prop="configcode">
                    <a-input v-if="is_new" v-model="record.configcode" />
                    <span v-else>{{record.configcode}}</span>
                </a-form-model-item>

                <a-form-model-item ref="configname" label="配置名称" prop="configname">
                    <a-input v-if="is_vue_task" v-model="record.configname" />
                    <span v-else>{{record.configname}}</span>
                </a-form-model-item>

                <a-form-model-item ref="enablenotify" label="是否启用通知" prop="enablenotify">
                    <a-radio-group v-if="is_vue_task" v-model="record.enablenotify">
                        <a-radio value="1" name="type">
                        是
                        </a-radio>
                        <a-radio value="2" name="type">
                        否
                        </a-radio>
                    </a-radio-group>
                    <span v-else>{{record.enablenotify == 1 ? '是' : '否'}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="record.enablenotify == 1" ref="channlecode" label="触达渠道" prop="channlecode">
                    <!-- <channelSelecter  v-if="is_vue_task" :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter> -->
                     <a-select v-if="is_vue_task" v-model="record.channlecode" style="width: 150px">
                        <a-select-option v-for="(value,name) in channlecodeList" :key="name" :value="name">
                            {{value}}
                        </a-select-option>
                    </a-select>
                    <span v-else>{{record.channlecode}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="record.enablenotify == 1" ref="passway" label="触达通道" prop="passway">
                    <!-- <passwaySelecter  v-if="is_vue_task" ref="passwaySelecterID"  @onPasswayCodeChange="handlePasswayChange" ></passwaySelecter> -->
                    <a-select v-if="is_vue_task" v-model="record.passway" style="width: 150px">
                        <a-select-option v-for="(value,name) in passwayList" :key="name" :value="name">
                            {{value}}
                        </a-select-option>
                    </a-select>
                    <span v-else>{{record.passway}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="record.enablenotify == 1" ref="receivertype" label="触达目标人群" prop="receivertype">
                    <a-select v-if="is_vue_task" v-model="record.receivertype" style="width: 150px">
                        <a-select-option v-for="(value,name) in receivertypeList" :key="name" :value="name">
                            {{value}}
                        </a-select-option>
                    </a-select>
                    <span v-else>{{receivertypeList[record.receivertype]}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="record.enablenotify == 1" ref="tagrule" label="触达目标规则" prop="tagrule">
                    <a-input v-if="is_vue_task" v-model="record.tagrule" />
                    <span v-else>{{record.tagrule}}</span>
                </a-form-model-item>

                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
// import passwaySelecter from '../com/passwaySelecter'
// import channelSelecter from '../com/channelSelecter'
import catalog from '../com/catalog'
import rangerule from '../com/rangerule'
import platformSelecter from '../com/platformSelecter'
const receivertypeList = {
    '02':'商户-门店',
    '03':'用户',
    '04':'设备',
    '05':'商户-门店-用户',
}

const channlecodeList = {
    'CHANNEL-006':'银响力终端',
    'CHANNEL-005':'商家银响力(中仑掌柜)'
}

const passwayList = {
    'PASSTYPE-003':'Websocket推送'
}
const m_title = {
    'addconfig':'新增配置',
    'detailconfig':'查看配置',
    'editconfig':'编辑配置',
};
export default {
    data() {
        return {
            receivertypeList,
            channlecodeList,
            passwayList,
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 12 },
            rules: {
                platformcode: [
                    { required: true, message: ' 请选择平台 ', trigger: 'blur' },
                ],
                configcode:[
                    { required: true, message: ' 请填写配置编码', trigger: 'blur' },
                ],
                configname:[
                    { required: true, message: '请填写配置名称', trigger: 'blur' },
                ],
                rangerule:[
                    { required: true, message: '请输入编码规则', trigger: 'blur' },
                ],
                tagrule:[
                    { required: true, message: '请输入编码规则', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                platformcode:'',
                platformname:'',//附加字段，子组件线上平台名称
                configcode:'',
                configname:'',
                catalogcode:'',//目录
                rangerule:'',
                enablenotify:'1',//是否启用通知  1-启用
                channlecode:'',//触达渠道，启用通知时必传
                passway:'',//触达通道，启用通知时必传
                receivertype:'',//触达目标人群：02：商户-门店   03：用户   04：设备   05：商户-门店-用户
                tagrule:'',
                // 触达目标规则：
                // 例如：receivertype为02（商户-门店）
                // 则配置该字段为：{shopcode}-{branchcode}
                // 该规则的变量和rangerule中的变量对应，且必须存在
                createuser:''
            },
            platformlist:[{text:'',value:''}]
        };
    },
    computed: {
        platformName(){
            let result = this.platformlist.find(item=>{return item.value == this.record.platformcode});
            if(result){
                return result.text
            }
            else{
                return ''
            }
        }
    },
    components:{
        // passwaySelecter,
        // channelSelecter,
        platformSelecter,
        catalog,
        rangerule
    },
    methods: {
        handleChannelChange(item){
            this.record.channlecode = item.value;
            this.$refs.passwaySelecterID.doSearch(item.value);
        },

        handlePasswayChange(v){
            this.record.passway = v.value;
        },
        handleCatlogChange(v){
            this.record.catalogcode = v;
        },
        handleRangeRuleChange(item){
            if(item.length > 0){
                this.record.rangerule = item[0].rangerule;
            }
        },
        handlePlatformChange(obj){
            this.record.platformcode = obj.platformcode;
            this.record.platformname = obj.platformname;
            this.platformlist = obj.platformlist;

        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    if(params.action == 'editconfig'){
                        that.$store
                            .dispatch({
                                type: "cloudconfig/updateconfiginfo",
                                params: {
                                    ...that.record,
                                    updateuser:this.G.getCurrentUser().username,
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'addconfig'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "cloudconfig/addconfiginfo",
                                params: {
                                    ...that.record,
                                    createuser:this.G.getCurrentUser().username,
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(query){
            let that = this;
            that.$store.dispatch({
                type: "cloudconfig/queryconfiginfo",
                params: {
                    platformcode:query.platformcode,
                    configcode:query.configcode
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    that.$refs.rangeRuleSelecter.init(result.rangerule,result.rangerulename)
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "addconfig";
        
        if (!this.is_new) {
            this.getDetail(query)
        }
        else{
            this.resetForm();
        }
        this.record.platformcode = query.platformcode
        this.is_vue_task = params.action != 'detailconfig'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
